import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './AppContext';
import './App.css';

// Components
import Navbar from './Navbar';
import Footer from './Footer';
import HeroBanner from './HeroBanner';
import StatsSection from './StatsSection';
import PayalSection from './PayalSection';
import MenSection from './MenSection';
import CollectionsGrid from './CollectionsGrid';
import AboutSection from './AboutSection';
import Testimonials from './Testimonials';
import OccasionSection from './OccasionSection';
import LookSection from './LookSection';
import NewLuxurySection from './NewLuxurySection';

// Pages
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import GiftingPage from './pages/GiftingPage';
import GiftingCategoryPage from './pages/GiftingCategoryPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';
import AdminPanel from './pages/AdminPanel';
import TermsPage from './pages/TermsPage';
import FaqPage from './pages/FaqPage';

import WhatsAppPopup from './WhatsAppPopup';
import LogoPreloader from './LogoPreloader';

import { useScrollReveal } from './useScrollReveal';

// ScrollToTop - scrolls to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    // Scroll immediately
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTo(0, 0);
    if (document.body) document.body.scrollTo(0, 0);

    // Fallback delay to ensure it scrolls to top after route transitions/DOM paint
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      if (document.documentElement) document.documentElement.scrollTo(0, 0);
      if (document.body) document.body.scrollTo(0, 0);
    }, 150);

    return () => clearTimeout(timer);
  }, [pathname]);
  return null;
};

// Home Component
const Home = () => {
  useScrollReveal();
  return (
    <>
      <HeroBanner />
      <StatsSection />

      <OccasionSection />
      <LookSection />

      {/* Tanishq & Indriya luxury sections placed before Complete Silver Range */}
      <NewLuxurySection />

      <PayalSection />
      <AboutSection />
      <MenSection />
      <CollectionsGrid />
      <Testimonials />
    </>
  );
};

// Layout wrapper to conditionally show Navbar and Footer
const LayoutWrapper = ({ children }) => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isHomePage = location.pathname === '/';

  return (
    <>
      {!isAdminPage && <Navbar />}
      <div
        className={`main-content-wrapper ${isHomePage ? 'is-home' : 'is-page'}`}
        style={{
          minHeight: '80vh',
          paddingTop: isHomePage ? '76px' : '88px'
        }}
      >
        {children}
      </div>
      {!isAdminPage && <WhatsAppPopup />}
      {!isAdminPage && <Footer />}
    </>
  );
};

function App() {
  return (
    <AppProvider>
      <LogoPreloader />
      <Router>
        <div className="App">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LayoutWrapper><Home /></LayoutWrapper>} />
            <Route path="/about" element={<LayoutWrapper><AboutPage /></LayoutWrapper>} />
            <Route path="/products" element={<LayoutWrapper><ProductsPage /></LayoutWrapper>} />
            <Route path="/gifting" element={<LayoutWrapper><GiftingPage /></LayoutWrapper>} />
            {/* Gifting category sub-pages */}
            <Route path="/gifting/:catSlug" element={<LayoutWrapper><GiftingCategoryPage /></LayoutWrapper>} />
            <Route path="/blog" element={<LayoutWrapper><BlogPage /></LayoutWrapper>} />
            <Route path="/contact" element={<LayoutWrapper><ContactPage /></LayoutWrapper>} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/terms" element={<LayoutWrapper><TermsPage /></LayoutWrapper>} />
            <Route path="/faq" element={<LayoutWrapper><FaqPage /></LayoutWrapper>} />
          </Routes>
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
